import noop from "lodash/noop";
import { useCallback } from "react";

const preventEvent = (event?: { preventDefault?: () => void; stopPropagation?: () => void }) => {
  event?.preventDefault?.();
  event?.stopPropagation?.();
};

type UseChatWindowHandlersParams = {
  conversationId: number;
  expanded: boolean;
  onSelect: (id: number) => void;
  onClose?: (id: number) => void;
  onMinimize?: (id: number) => void;
  onExpand?: (id: number, expand: boolean) => void;
  onUnMinimize?: (id: number) => void;
  setDropdownOpen: (open: boolean) => void;
};

export const useChatWindowHandlers = ({
  conversationId,
  expanded,
  onSelect,
  onClose = noop,
  onMinimize = noop,
  onExpand = noop,
  onUnMinimize = noop,
  setDropdownOpen
}: UseChatWindowHandlersParams) => {
  const handleUnMinimize = useCallback(
    (event?: React.SyntheticEvent) => {
      preventEvent(event);
      onSelect(conversationId);
      onUnMinimize(conversationId);
    },
    [conversationId, onSelect, onUnMinimize]
  );

  const handleExpand = useCallback(
    (event?: React.SyntheticEvent) => {
      preventEvent(event);
      onExpand(conversationId, !expanded);
    },
    [conversationId, expanded, onExpand]
  );

  const handleMinimize = useCallback(
    (event?: React.SyntheticEvent) => {
      preventEvent(event);
      onMinimize(conversationId); // no handleMinimize when embeded in the page (rather then floating)
      setDropdownOpen(false);
    },
    [conversationId, onMinimize, setDropdownOpen]
  );

  const handleClose = useCallback(
    (event?: React.SyntheticEvent) => {
      preventEvent(event);
      onClose(conversationId);
    },
    [conversationId, onClose]
  );

  return { handleUnMinimize, handleExpand, handleMinimize, handleClose };
};
